import { useState, useEffect, useCallback } from "react";

import { useNavigate } from "react-router-dom";

//Props Validations
import PropTypes from "prop-types";

//import assets

// import component
import Loader from "../../common/Loader";
import WeightToggleComponent from "../../common/WeightToggleComponent";
import FilterAcrossProductsToggleComponent from "../../common/FilterAcrossProductsToggleComponent";
import DataViewMode from "../../common/DataViewMode";
import Reset from "../../common/Reset";
import TTestDialog from "../../common/TTest/TTestDialog";
import BeautyAndWellbeingTTestDialog from "components/common/TTest/BeautyAndWellbeingTTestDialog";
import AnalysisTypeSelector from "../../common/AnalysisTypeSelector";
import OverallToggleComponent from "../../common/OverallToggleComponent";
import ViewToggle from "../../common/ViewToggle";
import InitialPopup from "../../common/InitialPopup";
import AnalysisTable from "../../common/analysisModule/AnalysisTable";
import AnalysisChart from "../../common/analysisModule/chart/AnalysisChart";
import VariableVisibility from "../../common/analysisModule/chart/VariableVisibility";
import AbsoluteCounts from "../../common/analysisModule/AbsoluteCounts";

// redux
import { useSelector, useDispatch } from "react-redux";
import {
    loadClaimsAnalysisResultState,
    loadIsClaimsAnalysisResultLoadingState,
    loadJustRightAnalysisResultState,
    loadDefaultJustRightAnalysisResultState,
    loadIsJustRightAnalysisResultLoadingState,
    loadAgreementAnalysisResultState,
    loadIsAgreementAnalysisResultLoadingState,
    loadOverallAnalysisResultState,
    loadIsOverallAnalysisResultLoadingState,
    loadSecondaryAnalysisResultState,
    loadIsSecondaryAnalysisResultLoadingState,
    loadIsItmDataState,
    loadDefaultAgreementAnalysisResultState,
    loadDefaultOverallAnalysisResultState,
    loadDefaultSecondaryAnalysisResultState,
    loadDefaultClaimsAnalysisResultState,
} from "store/features/analysisResultsSlice";
import { resetTTestStore } from "store/features/ttestSlice";
import { loadSecondaryRemovedKpiListState } from "store/features/analysisKpiSlice";
import { translateRemovedKpis } from "utils/analysisTable/analysisUtils";
import { toggleTextThemeSelection } from "store/features/textThemeSlice";
import { loadActiveTabState, clearPreserveModuleOnReturn } from "store/features/activeTabSlice";

// utils
import GetAgreementResult from "utils/apis/GetAgreementResult";
import GetOverallResult from "utils/apis/GetOverallResult";
import GetSecondaryResult from "utils/apis/GetSecondaryResult";
import GetClaimsResult from "utils/apis/GetClaimsResult";
import GetJustRightResult from "utils/apis/GetJustRightResult";

function SecondaryAttributeTab({ dataMappingData = {} }) {
    const navigate = useNavigate();

    //REDUX
    const dispatch = useDispatch();
    const selectedStudy = useSelector((state) => state.studyDataStore.selectedStudies);

    const productsSecondaryDataState = useSelector((state) => state.analysisResultsStore.secondaryAnalysisResult);
    const isLoading = useSelector((state) => state.analysisResultsStore.isSecondaryAnalysisResultLoading);
    const weightToggle = useSelector((state) => state.analysisResultsStore.weightToggle);
    const isConsumerFilterSelected = useSelector((state) => state.consumerFilterStore.filterSelectionStatus);

    const productsOrder = useSelector((state) => state.productsInfoStore.productsOrder);
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const productCategoryId = productCategoryData?.value || null;

    // toggle table and chart
    const [isTableShown, setIsTableShown] = useState(true);

    // t-test details
    const [tTestResult, setTTestResult] = useState([]);
    const [testLabel, setTestLabel] = useState("");

    // Analysis type
    const [isFisher, setIsFisher] = useState(false);
    const [legends, setLegends] = useState([]);

    const isDeodorants = process.env?.REACT_APP_DEODORANTS?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isOralCare = process.env?.REACT_APP_ORAL_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCleansing = process.env?.REACT_APP_SKIN_CLEANSING?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCare = process.env?.REACT_APP_SKIN_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const jarOrJustRightVariableCategory = isHairCare || isSkinCare ? "JAR" : "Just Right";
    const isBeautyAndWellbeing = isHairCare || isSkinCare;
    // box analysis code
    const overallBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.overallBoxAnalysisSelection);
    const secondaryBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.secondaryBoxAnalysisSelection);
    const agreementBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.agreementBoxAnalysisSelection);
    const claimsBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.claimsBoxAnalysisSelection);
    const analysisTypeValue = useSelector((state) => state.analysisTypeSelectionStore.secondaryAnalysisTypeValue);
    const boxAnalysisTypeSelection = useSelector((state) => state.analysisTypeSelectionStore.secondaryBoxAnalysisTypeSelection);
    const selectedDataset = useSelector((state) => state.analysisResultsStore.selectedDataset);
    const removedKpiStoreState = useSelector((state) => state.analysisKpiStore.secondaryRemovedKpiList);
    const isConceptRecallData = isHairCare && selectedDataset?.value === "concept_recall";
    const isConceptOnly = isHairCare && selectedDataset?.value === "concept";
    const isRecallOnly = isHairCare && selectedDataset?.value === "recall";

    // Translate removed KPIs when switching data view
    useEffect(() => {
        if (!dataMappingData?.columns?.length || !removedKpiStoreState?.length) return;
        let targetCategories;
        if (selectedDataset?.value === "concept") {
            targetCategories = ["Concept Secondary Attribute"];
        } else if (selectedDataset?.value === "concept_recall") {
            targetCategories = ["Concept Secondary Attribute", "Secondary Attribute"];
        } else {
            targetCategories = ["Secondary Attribute"];
        }
        const translated = translateRemovedKpis(removedKpiStoreState, dataMappingData.columns, targetCategories);
        dispatch(loadSecondaryRemovedKpiListState(translated));
    }, [selectedDataset?.value]);
    const moduleName = "secondary";

    const activeTab = useSelector((state) => state.activeTabStore.activeTabByModule.secondary);
    const preserveModuleOnReturn = useSelector((state) => state.activeTabStore.preserveModuleOnReturn);
    const setActiveTab = (tab) => dispatch(loadActiveTabState({ moduleName: "secondary", tab }));

    // concept_recall shared variable visibility mappings
    const [conceptChartMappings, setConceptChartMappings] = useState([]);
    const [recallChartMappings, setRecallChartMappings] = useState([]);
    const conceptRecallMergedMappings = [...conceptChartMappings, ...recallChartMappings];

    const clearResult = useCallback(() => {
        setTTestResult([]);
        setTestLabel("");
        dispatch(resetTTestStore());
        dispatch(toggleTextThemeSelection([])); 
        // onTTestDataReceived(false, "", "", "", null, "");
    }, []);

    // clear T Test
    useEffect(() => {
        clearResult();
    }, [weightToggle]);

    useEffect(() => {
        if (preserveModuleOnReturn === "secondary") {
            dispatch(clearPreserveModuleOnReturn());
        } else {
            dispatch(loadActiveTabState({ moduleName: "secondary", tab: "" }));
        }

    }, []);

    useEffect(() => {
        if (isOralCare || isSkinCleansing) {
            if (!isLoading) {
                if (!isConsumerFilterSelected) {
                    InitialPopup.general();
                }
            }
        }
    }, [isLoading, isConsumerFilterSelected, isOralCare, isSkinCleansing]);

    const clearTtest = (product, type) => {
        // clear t test
        if (type === "consumerFilterAll") {
            clearResult();
        } else if (type === "consumerFilter") {
            const tTestPro = tTestResult?.[0]?.colors?.map((datum) => datum.productCode) || [];
            const cfPc = product?.split("_")?.join(" ") || "";
            if (tTestPro.indexOf(cfPc) !== -1) {
                clearResult();
            }
        }
    };

    const getSecondaryResult = async ({ product = null, coreDataId = null, type = null, consumerFilter = null, pcs = [], selectedStudy = [], allAnalysisData = {}, fetchOnlyCurrent = false, boxAnalysisSelection = {} }) => {
        clearTtest(product, type);
        dispatch(loadIsSecondaryAnalysisResultLoadingState(true));
        dispatch(loadIsOverallAnalysisResultLoadingState(true));
        dispatch(loadIsAgreementAnalysisResultLoadingState(true));
        dispatch(loadIsClaimsAnalysisResultLoadingState(true));

        const secondaryResult = await GetSecondaryResult({ product, coreDataId, type, consumerFilter, pcs, selectedStudy, productsSecondaryDataState: allAnalysisData?.secondaryAnalysisResult || [], productsOrder, productCategoryId, boxAnalysisSelection: boxAnalysisSelection["secondary"], isHairCare });
        if (secondaryResult.length) {
            dispatch(loadSecondaryAnalysisResultState([...secondaryResult]));
            if (!type) {
                dispatch(loadDefaultSecondaryAnalysisResultState([...secondaryResult]));
            }
        }
        dispatch(loadIsSecondaryAnalysisResultLoadingState(false));

        const overallResult = await GetOverallResult({ product, coreDataId, type, consumerFilter, pcs, selectedStudy, productsSecondaryDataState: allAnalysisData?.overallAnalysisResult || [], productsOrder, productCategoryId, boxAnalysisSelection: boxAnalysisSelection["overall"] });
        if (overallResult) {
            overallResult.forEach((product) => {
                product.scores.forEach((ele) => {
                    if (ele.backendVariable.includes("ITM_") && ele.mean) {
                        dispatch(loadIsItmDataState(true));
                    }
                });
            });
            dispatch(loadOverallAnalysisResultState([...overallResult]));
            if (!type) {
                dispatch(loadDefaultOverallAnalysisResultState([...overallResult]));
            }
        }

        const agreementResult = await GetAgreementResult({ product, coreDataId, type, consumerFilter, pcs, selectedStudy, productsSecondaryDataState: allAnalysisData?.agreementAnalysisResult || [], productsOrder, productCategoryId, boxAnalysisSelection: boxAnalysisSelection["agreement"], isHairCare });
        if (agreementResult) {
            dispatch(loadAgreementAnalysisResultState([...agreementResult]));
            if (!type) {
                dispatch(loadDefaultAgreementAnalysisResultState([...agreementResult]));
            }
        }

        const claimsResult = await GetClaimsResult({ product, coreDataId, type, consumerFilter, pcs, selectedStudy, productsSecondaryDataState: allAnalysisData?.claimsAnalysisResult || [], productsOrder, productCategoryId, boxAnalysisSelection: boxAnalysisSelection["claims"] });
        if (claimsResult) {
            dispatch(loadClaimsAnalysisResultState([...claimsResult]));
            if (!type) {
                dispatch(loadDefaultClaimsAnalysisResultState([...claimsResult]));
            }
        }

        if (!isDeodorants) {
            dispatch(loadIsJustRightAnalysisResultLoadingState(true));
            const justRightResult = await GetJustRightResult(product, coreDataId, type, consumerFilter, pcs, selectedStudy, allAnalysisData?.justRightAnalysisResult || [], productsOrder, productCategoryId, jarOrJustRightVariableCategory);
            dispatch(loadJustRightAnalysisResultState([...justRightResult]));
            if (!type) {
                dispatch(loadDefaultJustRightAnalysisResultState([...justRightResult]));
            }
            dispatch(loadIsJustRightAnalysisResultLoadingState(false));
        }

        dispatch(loadIsAgreementAnalysisResultLoadingState(false));
        dispatch(loadIsOverallAnalysisResultLoadingState(false));
        dispatch(loadIsClaimsAnalysisResultLoadingState(false));
        console.log("fetchOnlyCurrent", fetchOnlyCurrent);
    };

    useEffect(() => {
        async function fetchAnalysisResult() {
            if (!productsSecondaryDataState.length) {
                await getSecondaryResult({
                    product: null,
                    coreDataId: null,
                    type: null,
                    consumerFilter: null,
                    pcs: [],
                    selectedStudy,
                    allAnalysisData: [],
                    fetchOnlyCurrent: true,
                    boxAnalysisSelection: {
                        overall: overallBoxAnalysisSelection,
                        secondary: secondaryBoxAnalysisSelection,
                        agreement: agreementBoxAnalysisSelection,
                        claims: claimsBoxAnalysisSelection,
                    },
                });
            }
        }

        if (selectedStudy.length === 0) {
            navigate("/studies");
        } else if (!productsSecondaryDataState.length) {
            fetchAnalysisResult();
        }
    }, [selectedStudy]);

    return (
        <>
            {isLoading && <Loader />}
            <div
                className="card-btns"
                style={{
                    padding: "0px 0px",
                    margin: "10px 0px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                }}
            >
                <div
                    className=" d-flex"
                    style={{ alignItems: "center" }}
                >
                    <div>
                        <ViewToggle
                            value={isTableShown}
                            setValue={setIsTableShown}
                            labels={["Table", "Chart"]}
                        />
                    </div>
                    <div
                        style={{
                            marginLeft: "1rem",
                            zIndex: "3",
                            width: "150px",
                        }}
                    >
                        <AnalysisTypeSelector
                            value={analysisTypeValue}
                            pageName="secondaryAttributeAnalysis"
                            variableCategory={isHairCare ? "Secondary Attribute,Concept Secondary Attribute" : "Secondary Attribute"}
                            handleFilterSubmit={getSecondaryResult}
                            mappings={dataMappingData.columns}
                            moduleName="secondary"
                            clearResult={clearResult}
                        />
                    </div>
                    {analysisTypeValue?.value === "box_analysis" && isOralCare &&
                        <AbsoluteCounts
                            moduleName="secondary"
                        />
                    }
                </div>

                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                    }}
                >
                    <OverallToggleComponent />
                    <WeightToggleComponent />
                    <FilterAcrossProductsToggleComponent />
                    {isHairCare && <DataViewMode />}
                    {isBeautyAndWellbeing ? (
                        <BeautyAndWellbeingTTestDialog
                            variableCategory="Secondary Attribute"
                            analysisLevelData={{
                                moduleName: "secondary",
                                analysisTypeValue: analysisTypeValue,
                                boxAnalysisTypeSelection: boxAnalysisTypeSelection,
                                boxAnalysisSelection: secondaryBoxAnalysisSelection,
                            }}
                            functionsSettings={{
                                setIsFisher: setIsFisher,
                                setLegends: setLegends,
                                setTTestResult: setTTestResult,
                                setTestLabel: setTestLabel,
                                clearResult: clearResult,
                                // onTTestDataReceived: onTTestDataReceived,
                            }}
                            tabData={{
                                productsSecondaryDataState: productsSecondaryDataState,
                            }}
                        />
                    ) : (
                        <TTestDialog
                            variableCategory="Secondary Attribute"
                            analysisLevelData={{
                                moduleName: "secondary",
                                analysisTypeValue: analysisTypeValue,
                                boxAnalysisTypeSelection: boxAnalysisTypeSelection,
                                boxAnalysisSelection: secondaryBoxAnalysisSelection,
                                mappings: dataMappingData.columns,
                            }}
                            functionsSettings={{
                                setIsFisher: setIsFisher,
                                setLegends: setLegends,
                                setTTestResult: setTTestResult,
                                setTestLabel: setTestLabel,
                                clearResult: clearResult,
                                // onTTestDataReceived: onTTestDataReceived,
                            }}
                            tabData={{
                                productsSecondaryDataState: productsSecondaryDataState,
                            }}
                        />
                    )}
                    <Reset clearTTestResult={clearResult} />
                </div>
            </div>
            <div
                style={{
                    minHeight: "calc(100vh - 300px)",
                }}
            >
                {isTableShown ? (
                    <>
                        <AnalysisTable
                            productsSecondaryData={productsSecondaryDataState}
                            handleFilterSubmit={getSecondaryResult}
                            selectedStudy={selectedStudy}
                            analysisLevelData={{
                                tableConfig: {
                                    stickyColumns: ["KPI"],
                                },
                                moduleName: moduleName,
                                analysisTypeValue: analysisTypeValue,
                                boxAnalysisTypeSelection: boxAnalysisTypeSelection,
                                boxAnalysisSelection: secondaryBoxAnalysisSelection,
                                mappings: dataMappingData.columns,
                            }}
                            tTest={{
                                tTestLegends: legends,
                                isFisher: isFisher,
                                tTestResult: tTestResult,
                                testLabel: testLabel,
                            }}
                            // onTextThemeSelectionChange={onTextThemeSelectionChange}
                            settings={{
                                activeTab: activeTab,
                                setActiveTab: setActiveTab,
                            }}
                        />
                        {/* <SecondaryAttributeTable
                            productSelected={productsRow}
                            productsSecondaryData={productsSecondaryDataState}
                            activeMacroCategory={activeMacroCategory}
                            dataMappingData={dataMappingData}
                            column1={dataMappingData.columns.map((col) => col.macroCategory)}
                            column2={dataMappingData.columns}
                            tTestResult={tTestResult}
                            keyMapDisplayLabelConsumerFilter={keyMapDisplayLabelConsumerFilter}
                            testLabel={testLabel}
                            handleFilterSubmit={getSecondaryResult}
                            selectedStudy={selectedStudy}
                        /> */}
                    </>
                ) : isConceptRecallData || isConceptOnly || isRecallOnly ? (
                    <>
                        {(isConceptRecallData || isConceptOnly || isRecallOnly) && (
                            <VariableVisibility
                                mappings={isConceptRecallData ? conceptRecallMergedMappings : isConceptOnly ? conceptChartMappings : recallChartMappings}
                                moduleName="secondary"
                            />
                        )}
                    <div
                        style={{
                            minHeight: "calc(-300px + 100vh)",
                            display: "flex",
                            justifyContent: isConceptOnly || isRecallOnly ? "flex-start" : "space-between",
                            height: "100%",
                        }}
                    >
                        <div
                            style={{
                                width: isConceptOnly || isRecallOnly ? "100%" : "49%",
                                borderTop:  isConceptRecallData ? "1px solid #c8c8c8" : "none",
                                borderRight: isConceptRecallData ? "1px solid #c8c8c8" : "none",                                            
                                paddingTop: "20px",
                                marginTop: "10px",
                                height: "100%",
                            }}
                        >
                            <div style={{ textAlign: "center", marginBottom: "20px" }}>
                                {isConceptRecallData ? "Concept" : ""}
                            </div>
                            <AnalysisChart
                                productsSecondaryData={productsSecondaryDataState}
                                analysisLevelData={{
                                    isConceptDataShown: isConceptRecallData || isConceptOnly,
                                    isRecallDataShown: isRecallOnly,
                                    isSplitConceptRecall: isConceptRecallData,
                                    moduleName: "secondary",
                                    analysisTypeValue: analysisTypeValue,
                                    boxAnalysisTypeSelection: boxAnalysisTypeSelection,
                                    boxAnalysisSelection: secondaryBoxAnalysisSelection,
                                    mappings: dataMappingData.columns,
                                }}
                                onVariableVisibilityMappingsChange={isConceptRecallData || isConceptOnly ? setConceptChartMappings : setRecallChartMappings}
                                settings={{ activeTab: activeTab, setActiveTab: setActiveTab }}
                                tTest={{ tTestLegends: legends, isFisher: isFisher, tTestResult: tTestResult, testLabel: testLabel }}
                            />
                        </div>
                        {isConceptRecallData && (
                            <div
                                style={{
                                    width: "49%",
                                    borderTop: "1px solid #c8c8c8",
                                    borderRight: "1px solid #c8c8c8",
                                    paddingTop: "20px",
                                    marginTop: "10px",
                                    height: "100%",
                                }}
                            >
                                <div style={{ textAlign: "center", marginBottom: "20px" }}>Recall</div>
                                <AnalysisChart
                                    productsSecondaryData={productsSecondaryDataState}
                                    analysisLevelData={{
                                        isRecallDataShown: true,
                                            isSplitConceptRecall: true,
                                        moduleName: "secondary",
                                        analysisTypeValue: analysisTypeValue,
                                        boxAnalysisTypeSelection: boxAnalysisTypeSelection,
                                        boxAnalysisSelection: secondaryBoxAnalysisSelection,
                                        mappings: dataMappingData.columns,
                                    }}
                                    onVariableVisibilityMappingsChange={setRecallChartMappings}
                                    settings={{ activeTab: activeTab, setActiveTab: setActiveTab }}
                                    tTest={{ tTestLegends: legends, isFisher: isFisher, tTestResult: tTestResult, testLabel: testLabel }}
                                />
                            </div>
                        )}
                    </div>
                    </>
                ) : (
                    <AnalysisChart
                        productsSecondaryData={productsSecondaryDataState}
                        analysisLevelData={{
                            moduleName: "secondary",
                            analysisTypeValue: analysisTypeValue,
                            boxAnalysisTypeSelection: boxAnalysisTypeSelection,
                            boxAnalysisSelection: secondaryBoxAnalysisSelection,
                            activeTab: activeTab,
                            mappings: dataMappingData.columns,
                        }}
                        settings={{
                            activeTab: activeTab,
                            setActiveTab: setActiveTab,
                        }}
                        tTest={{
                            tTestLegends: legends,
                            isFisher: isFisher,
                            tTestResult: tTestResult,
                            testLabel: testLabel,
                        }}
                    />

                    // <AnalysisChart
                    //     productSelected={productsRow}
                    //     productsSecondaryData={productsSecondaryDataState}
                    //     dataMappingData={dataMappingData}
                    //     column1={[activeMacroCategory]}
                    //     column2={[activeMacroCategoryDisplayLabels]}
                    //     tTestResult={tTestResult}
                    //     chartType={chartType}
                    //     analysisType={"overallKpiAnalysis"}
                    //     colorsType={"secondaryAttributeColors"}
                    //     legends={legends}
                    //     componentName={"overallKpiDataState"}
                    //     pageName={"secondaryAttributeAnalysis"}
                    //     selectedStudy={selectedStudy}
                    //     testLabel={testLabel}
                    //     removedList={removedList}
                    //     dataView={dataView}
                    // />
                )}
                {/* {!isFisher && tTestResult.length !== 0 && legends.length === 2 && returnLegends()} */}
                {/* <style>
                    {`
                      ul.macroCategory {
                        padding: 0;
                        display: flex;
                        list-style: none;
                        overflow: hidden;
                      }
                      ul.macroCategory li {
                        transition: background 0.3s, color 0.3s;
                        transform: skew(150deg); 
                        padding:10px;
                      }
                      
                      ul.macroCategory li a {
                        display: block; 
                        text-decoration: none;
                        padding: 12px 20px;
                        transform: skew(-150deg); 
                        color: #FFFFFF;
                        font-weight: 600;
                        letter-spacing: 0.4px;
                        font-size: 14px;
                      }

                      .active,
                      a:hover {
                        color: #000000 !important;
                      }
                      .skew-single-side {
                        padding-left: 16px;
                        margin-left: -16px;
                      }
                      
                      `}
                </style>

                <ul className="macroCategory">
                    {sortedData?.map((col, i) => {
                        const isDisabled = disabledMacroCategories[col] || false;
                        const isActive = activeMacroCategory === col;
                        const textColor = getTextColor(isActive, isDisabled);
                        const pointerEvents = getPointerEvents();
                        const liKey = i + 1;

                        return (
                            <li
                                key={liKey}
                                className="skew-single-side"
                                style={{
                                    background: isDisabled ? "#ccc" : macroCategoryBackgroundColors[i], // Gray out background if disabled
                                    opacity: isDisabled ? 0.6 : 1,
                                    pointerEvents: isDisabled ? "none" : "auto",
                                    position: "relative",
                                }}
                            >
                                <span title={isDisabled ? "No data present" : ""}>
                                    <Link
                                        onClick={() => !isDisabled && handleCategoryClick(col)}
                                        className={`${isActive && "active"}`}
                                        style={{
                                            cursor: isDisabled ? "default" : "pointer",
                                            color: isDisabled ? "#999" : textColor, // Gray out text if disabled
                                            pointerEvents: pointerEvents,
                                        }}
                                    >
                                        {col}
                                    </Link>
                                </span>
                            </li>
                        );
                    })}
                </ul> */}
                {/* {!["overall", "claims"].includes(moduleName) && (
                    <SkewTabs
                        tableData={{
                            productsSecondaryDataState: productsSecondaryDataState,
                        }}
                        settings={{
                            activeTab: activeTab,
                            setActiveTab: setActiveTab,
                        }}
                        analysisView={{
                            moduleName: moduleName,
                            mappings:  dataMappingData.columns,
                        }}
                    />
                )} */}
            </div>
            {/* <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end", // Changed from "space-between" to "flex-end"
                    position: "sticky",
                    left: 0,
                }}
            >
                <p
                    style={{
                        marginBottom: 0,
                        color: "#495057",
                        fontWeight: 600,
                        fontSize: 14,
                    }}
                >
                    Likert scale size is indicated in brackets () next to each variable
                </p>
            </div> */}
        </>
    );
}

// Typechecking props for the SecondaryAttributeTab
SecondaryAttributeTab.propTypes = {
    dataMappingData: PropTypes.object,
};

export default SecondaryAttributeTab;
